module.exports = __webpack_public_path__ + "d521cde14c47490040594e3485ff1b22.svg";